module.exports = __webpack_public_path__ + "static/media/women-fas-cat-1.2bce8588.png";